import { z } from 'zod';

import { EscrowPaymentHistoryItemId, LosId, PaymentId, QcDocumentId } from '../../BrandedIds';
import { Actor } from '../../events/BaseLoanEvent';
import { EscrowPaymentHistoryItemStatus } from '../../loan/EscrowPaymentHistoryItem';
import { zodTemporalInstant, zodTemporalPlainDate } from '../../Temporal';
import { zodBrandedString, zodBrandedUuid } from '../../utils';

export const ExportableEscrowPaymentHistoryItem = z
  .object({
    id: zodBrandedUuid<EscrowPaymentHistoryItemId>(),
    loanId: zodBrandedString<LosId>(),

    type: z.enum(['initial', 'manualUpdate', 'shortagePayment', 'analysis', 'constructionToPermanent']),
    createdAt: zodTemporalInstant,
    newMonthlyAmount: z.number(),
    actor: Actor,
    status: EscrowPaymentHistoryItemStatus.optional(),

    effectiveDate: zodTemporalPlainDate.optional(),
    escrowShortageAnalysisId: zodBrandedUuid<EscrowPaymentHistoryItemId>().optional(),
    paymentId: zodBrandedUuid<PaymentId>().optional(),
    shortageAmount: z.number().optional(),
    newMonthlyAmountIfShortagePaidUpfront: z.number().optional(),
    qcDocumentId: zodBrandedUuid<QcDocumentId>().optional(),
  })
  .meta({ title: 'EscrowPaymentHistoryItem' });

export type ExportableEscrowPaymentHistoryItem = z.infer<typeof ExportableEscrowPaymentHistoryItem>;
